// header js for hover mega menu
document.querySelectorAll('.mega-menu').forEach((details) => {
  const summary = details.querySelector('summary');
  const content = details.querySelector('.mega-menu__content');

  // Only proceed if both summary and content exist
  if (summary && content) {
    let isHovered = false;
    // Open the dropdown when the mouse enters the summary or the content
    const openDropdown = () => {
      isHovered = true;
      details.setAttribute('open', '');
    };

    // Close the dropdown when the mouse leaves both the summary and the content
    const closeDropdown = () => {
      isHovered = false;
      setTimeout(() => {
        if (!isHovered) {
          details.removeAttribute('open');
        }
      }, 100); // Slight delay to handle quick transitions
    };

    summary.addEventListener('mouseenter', openDropdown);
    summary.addEventListener('mouseleave', closeDropdown);

    content.addEventListener('mouseenter', openDropdown);
    content.addEventListener('mouseleave', closeDropdown);
  }
});

// js for close the mobile menu - handle multiple instances
function setupMobileMenuClose() {
  // Use querySelectorAll to find ALL mobile menu close buttons
  const mobileMenuCloseButtons = document.querySelectorAll('#mobile-menu-close');
  console.log('Mobile menu close buttons found:', mobileMenuCloseButtons.length);

  if (mobileMenuCloseButtons.length > 0) {
    mobileMenuCloseButtons.forEach((button, index) => {
      console.log(`Setting up mobile menu close button ${index + 1}`);

      // Remove any existing listeners first
      button.removeEventListener('click', handleMobileMenuClose);
      button.removeEventListener('mousedown', handleMobileMenuClose);

      // Add event listeners
      button.addEventListener('click', handleMobileMenuClose);
      button.addEventListener('mousedown', handleMobileMenuClose);
    });

    console.log('Mobile menu close event listeners added to all buttons');
    return true;
  }
  return false;
}

function handleMobileMenuClose(e) {
  console.log('Mobile menu close triggered:', e.type);
  e.preventDefault();
  e.stopPropagation();
  e.stopImmediatePropagation();

  // Find the closest menu drawer container for this specific button
  const clickedButton = e.target.closest('#mobile-menu-close');
  let menuDrawer = clickedButton?.closest('header-drawer')?.querySelector('#Details-menu-drawer-container');

  // If not found in closest header-drawer, try to find any open menu drawer
  if (!menuDrawer) {
    const allMenuDrawers = document.querySelectorAll('#Details-menu-drawer-container');
    for (let drawer of allMenuDrawers) {
      if (drawer.hasAttribute('open')) {
        menuDrawer = drawer;
        break;
      }
    }
  }

  console.log('Menu drawer found:', !!menuDrawer);

  if (menuDrawer) {
    const menuSummary = menuDrawer.querySelector('summary');

    // Remove the "open" attribute
    if (menuDrawer.hasAttribute('open')) {
      menuDrawer.removeAttribute('open');
      console.log('Menu drawer closed');
    }

    // Update "aria-expanded" attribute
    if (menuSummary) {
      menuSummary.setAttribute('aria-expanded', 'false');
    }

    // Remove overflow hidden class
    if (document.body.classList.contains('overflow-hidden-tablet')) {
      document.body.classList.remove('overflow-hidden-tablet');
    }
  } else {
    // Fallback: Close ALL open menu drawers
    console.log('No specific menu drawer found, closing all open drawers');
    const allMenuDrawers = document.querySelectorAll('#Details-menu-drawer-container[open]');
    allMenuDrawers.forEach((drawer) => {
      drawer.removeAttribute('open');
      const summary = drawer.querySelector('summary');
      if (summary) {
        summary.setAttribute('aria-expanded', 'false');
      }
    });

    if (document.body.classList.contains('overflow-hidden-tablet')) {
      document.body.classList.remove('overflow-hidden-tablet');
    }
  }
}

// Try immediately
if (!setupMobileMenuClose()) {
  // If not found, try with timeout
  setTimeout(() => {
    if (!setupMobileMenuClose()) {
      // If still not found, use MutationObserver to watch for DOM changes
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'childList') {
            if (setupMobileMenuClose()) {
              observer.disconnect();
            }
          }
        });
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true,
      });
    }
  }, 100);
}

// Also add a global click handler as a fallback for any mobile menu close buttons
document.addEventListener('click', function (e) {
  // Check if clicked element is #mobile-menu-close or a child of it
  const closeButton = e.target.closest('#mobile-menu-close');
  if (closeButton) {
    console.log('Global mobile menu close handler triggered');
    handleMobileMenuClose(e);
  }
});

// Close menu drawer when clicking outside
document.addEventListener('click', function (event) {
  const detailsMenuDrawer = document.getElementById('Details-menu-drawer-container');
  const menuDrawer1 = document.getElementById('menu-drawer');

  // Ensure `Details-menu-drawer-container` has the `open` attribute
  if (detailsMenuDrawer && detailsMenuDrawer.hasAttribute('open')) {
    // Check if the click is outside `menu-drawer`
    if (menuDrawer1 && !menuDrawer1.contains(event.target)) {
      // Remove the "overflow-hidden-tablet" class from <body> if present
      if (document.body.classList.contains('overflow-hidden-tablet')) {
        document.body.classList.remove('overflow-hidden-tablet');
      }
    }
  }
});
